// Un enlace de YouTube/Vimeo -> la URL que se puede meter en un <iframe>.
//
// La misma cuenta de tres pantallas ya hacia esto por su cuenta (ResourcesView,
// PublicResourcePortal, HipaaSeatBundle). Esta copia existe porque el Centro de
// Ayuda la necesitaba y anadir una CUARTA no tenia sentido; las tres viejas
// siguen donde estaban y se pueden migrar aqui cuando se toquen.
//
// Solo YouTube y Vimeo: son los dos unicos hosts que la CSP del SPA permite
// enmarcar (`frame-src` en crm-app/public/staticwebapp.config.json). Cualquier
// otro enlace devuelve null y quien llama decide que hacer con el.

const YOUTUBE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/;
const VIMEO = /vimeo\.com\/(?:video\/)?(\d+)/;

/**
 * @param {string} url enlace tal cual lo escribio una persona
 * @returns {string|null} URL para el src de un <iframe>, o null si no es video
 */
export function videoEmbedUrl(url) {
  const s = String(url || '');
  const yt = s.match(YOUTUBE);
  // nocookie: no deja la cookie de publicidad de YouTube en el navegador del
  // agente solo por abrir un articulo de ayuda.
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}`;
  const vm = s.match(VIMEO);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}
